<template>
  <div id="Word" class="Page Word">
    <Shape ref="shape" />
    <div class="Page_wrapper">
      <img src="/assets/images/dead.svg" alt="Tête de mort" />
      <transition name="title" appear>
        <h2>Code du Tresor</h2>
      </transition>

      <transition name="fade" appear mode="out-in">
        <p v-if="error" key="error" class="error">Lorsqu'on ne sait pas vers quel port on navigue, aucun vent n'est le bon.</p>
        <p v-else key="ok">{{ $tools.isTouchDevice() ? 'Touchez' : 'Cliquez' }} sur un chiffre pour changer.</p>
      </transition>

      <transition name="content" appear>
        <!-- <form autocomplete="off" spellcheck="false" autocorrect="off" @submit.prevent="validate">
          <div class="Word_word" :class="{ 'Word_word_error': error }">
            <input class="Word_secret" v-model="secret" placeholder="1XXX" pattern="^[0–9]$" type="text" ref="secret" spellcheck="false" autocorrect="off" :maxlength="word.length" :minlength="word.length" />
            <div class="Word_letters">
              <span class="Word_letter" v-for="(l, index) in word.length" :key="index"></span>
            </div>
          </div>
        </form> -->

        <div class="Lock">
          <div class="Lock_col" ref="cols" v-for="c in 4" :key="c - 1" @click="changeNumber(c - 1)">
            <div class="Lock_col_wrapper" :style="{ transform: 'translateY(' + - cols[c - 1] * 10 + '%)' }">
              <span class="Lock_number" v-for="i in 10" :key="i - 1">{{ i - 1 }}</span>
            </div>
          </div>
        </div>
      </transition>
      
      <transition name="cta" appear>
        <button class="Cta" @click="validate"><i class="fad fa-treasure-chest"></i> Valider</button>
      </transition>

      <div class="Close" @click="close"><img class="Shape_optim" src="/assets/images/shape-small.svg" /><i class="fad fa-times-circle"></i></div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import page from "@/mixins/page"

import Shape from '@/components/partial/Shape'

export default {
  components: { Shape },
  mixins: [ page ],
  data () {
    return {
      code: [
        1, 4, 5, 4
      ],
      isOk: false,
      onSubmit: false,
      error: false,
      cols: [
        2, 0, 2, 0
      ]
    }
  },
  methods: {
    changeNumber(i)
    {
      const col = this.cols[i]
      this.cols[i] = col >= 9 ? 0 : col + 1
      this.$forceUpdate()

      this.number.play()
    },
    validate()
    {
      if(this.isOk || this.onSubmit) return

      this.onSubmit = true

      if(JSON.stringify(this.code)==JSON.stringify(this.cols))
      {
        this.close()
        this.isOk = true
        this.$emit('gameIsCompleted')

        this.$ga.event('final', 'ok' );

      }else{
        this.bad = new Howl({
          src: ['/assets/sounds/pError.wav']
        });
        this.bad.play()

        this.$ga.event('final', 'error' );

        this.error = true

        TweenMax.to(this.$el, 0.5, { rotation: -10, ease: Elastic.easeIn })
        TweenMax.to(this.$el, 0.5, { delay: 0.5, rotation: 0, ease: Elastic.easeOut, onComplete: () => {
          this.onSubmit = false
        } })
      }
    },
    close()
    {
      this.close = new Howl({
        src: ['/assets/sounds/close.mp3']
      });
      this.close.play()

      this.$el.querySelector('.Shape').classList.remove('Shape_indice')
      this.$emit('closeInteraction')
    }
  },
  created () {
  },
  mounted () {
    setTimeout( () => {
      this.$el.querySelector('.Shape').classList.add('Shape_indice')
    }, 10)

    this.open = new Howl({
      src: ['/assets/sounds/open.mp3']
    });
    this.open.play()
      
    this.pOpen = new Howl({
      src: ['/assets/sounds/openP.mp3']
    });
    this.pOpen.play()

    this.number = new Howl({
      src: ['/assets/sounds/number.wav']
    });
  }
}
</script>

<style lang="stylus" scoped>

.Word

  position fixed
  top 0px
  left 0px
  z-index 10
  overflow visible
  pointer-events auto

  .error

    color $red

  .Lock

    display table
    position relative
    margin 0px auto

    &:before

      content ''
      position absolute 
      top 50%
      width 60px
      background-color $blue
      height 3px
      transform translateY(-50%)
      right calc(100% + 6px)

    &:after

      content ''
      position absolute 
      top 50%
      width 60px
      background-color $blue
      height 3px
      transform translateY(-50%)
      left calc(100% + 6px)

    &_col

      width 40px
      float left
      height 60px
      cursor pointer
      border-top 3px solid $blue
      border-bottom 3px solid $blue
      border-left 1px solid $blue
      border-right 1px solid $blue
      overflow hidden
      margin 0px 3px
      box-sizing border-box
      position relative
      border-radius 4px

      &:before

        content ''
        position absolute
        top 0px
        left 0px
        width 100%
        height 20%
        z-index 1
        background: linear-gradient(180deg, rgba(2,25,65,0.3) 0%, rgba(0,0,0,0) 100%);

      &:after

        content ''
        position absolute
        bottom 0px
        left 0px
        width 100%
        height 20%
        z-index 1
        background: linear-gradient(0deg, rgba(2,25,65,0.3) 0%, rgba(0,0,0,0) 100%);

      &_wrapper

        transform translateY(-30%)
        transition 0.6s $ease

    &_number

      display block
      height 100%
      position relative
      top 5px
      font-family $fsecondary
      font-size 35px
      box-sizing border-box
      margin-top 10%
      line-height 30px

  &_word

    position relative
    display table
    margin auto auto

    &_error

      input

        border-color $red!important

  input[type="text"]

    font-size 40px
    border 0px
    max-width 360px
    width 100%
    display table
    box-sizing border-box
    line-height 40px
    border-bottom 4px solid $blue
    border-top 4px solid $blue
    padding-bottom 0px
    margin 0px
    overflow hidden
    text-align center
    background-color transparent
    color $blue
    border-radius 0px
    appearance none
    font-family $fsecondary
    letter-spacing 1.05em
    min-width auto
    padding 8px 8px
    padding-left 50px
    transition border-color 0.8s linear

    @media $small

      font-size 30px
      letter-spacing 0.85

    &::placeholder

      font-size 40px
      color $blue
      text-align center
      line-height 40px
      opacity 0.3
      font-family $fsecondary

      @media $small

        font-size 30px
        letter-spacing 0.85

  &_letters

    width 100%
    position absolute
    bottom 0px
    left 0px
    display flex
    flex-direction row
    align-items center
    justify-content flex-start

    // span

    //   background-color $blue
    //   opacity 0.5
    //   height 4px
    //   width 50px
    //   margin 0px 5px
    //   display block
    //   position relative

    //   &:before

    //     content ''
    //     pointer-events none
    //     top -45px
    //     left 0px
    //     background-color $blue
    //     opacity 1
    //     display block
    //     position absolute
    //     height 4px
    //     width 50px

  img

    width 65px

  .Page_wrapper

    max-width 860px
    position relative
    width 70%
    text-align center

    @media $large

      width 100%
      max-width 1024px

    @media $small

      width 100%

  .longuevue

    position absolute
    left 72%
    bottom 20%
    width 100px

  .ancre

    position absolute 
    left 80%
    width 120px
    bottom 13%

</style>
